import React, { Component } from 'react';
import { ComboBox, DropdownSkeleton } from 'carbon-components-react';
import PropTypes from 'prop-types';
import { api } from '../../../helpers/api/api';

export default class DataApproverComboBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: []
    };
    this.onChange = this.onChange.bind(this);
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const items = await this.getItems();
    this.setState({ items, loading: false });
  }

  onChange = (selectedItem) => {
    const item = selectedItem ? selectedItem.selectedItem : null;
    this.props.onChange(item);
  };

  getItems = async () => {
    let items = [];

    try {
      items = (await api.getAll('/audit/approvers')).data;
    } catch (error) {
      console.error(error);
      this.props.onError(error);
    }
    return items;
  };

  render() {
    return this.state.loading ? (
      <DropdownSkeleton />
    ) : (
      <ComboBox
        id="comboBoxDataApprover"
        disabled={this.state.items < 1}
        placeholder="Choose a Data Approver"
        items={this.state.items}
        onChange={this.onChange}
        shouldFilterItem={({ item, inputValue }) =>
          item.fullName.toLowerCase().includes(inputValue.toLowerCase()) ||
          item.userName.toLowerCase().includes(inputValue.toLowerCase())
        }
        itemToString={(item) => (item ? item && item.name : '')}
      />
    );
  }
}

DataApproverComboBox.propTypes = {
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired
};
DataApproverComboBox.defaultProps = {};
